module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/area-4-ca5f41475403b14471d385250d683b2e.jpg";